export const Success = ({ children }: React.PropsWithChildren) => (
  <div className={'text-label-large text-success-default'}>{children}</div>
);
